import { PropsWithChildren } from "react";
import {
  Dialog as BaseDialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../shadcn/Dialog";

const Dialog = ({
  title,
  description,
  children,
  isOpen = false,
  onOpenChange,
  className
}: PropsWithChildren & {
  title: string;
  description?: string;
  isOpen?: boolean;
  onOpenChange: (open: boolean) => void;
  className?: string;
}) => {
  return (
    <BaseDialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className={`bg-[var(--dialog-background)] ${className || ''}`}>
        <DialogHeader>
          <DialogTitle className={title && !description ? "border-b pb-4 -mx-6 px-6" : ""}>{title}</DialogTitle>
          {description && (
            <p className="text-sm text-gray-secondary pt-1 pb-4 border-b -mx-6 px-6">{description}</p>
          )}
          <DialogDescription asChild>
            <div>{children}</div>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </BaseDialog>
  );
};

export default Dialog;
